import { AutoComplete } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IOfferClassificationDefaultClassificationsProps } from "./models";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRuleOfferClassif.";

export const OfferClassificationDefaultClassifications = ({
  options,
}: IOfferClassificationDefaultClassificationsProps) => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        name="defaultClassifExternal"
        label={t(translationPath + "default_classification")}
        getOptionLabel={({ name }) => name}
        options={options}
        size="small"
      />
    </Grid>
  );
};
